<div class="cards content-max-width">
    <div class="container">
        <ng-content></ng-content>
    </div>
</div>